'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToThreadChannels = exports.subscribeToThreadChannelsAction = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _getClient = require('../../pubsub/selectors/getClient');

var _getThreadChannels = require('../../threads/selectors/getThreadChannels');

var _onMessageReceived = require('../../pubsub/actions/onMessageReceived');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var subscribeToThreadChannelsAction = exports.subscribeToThreadChannelsAction = (0, _reduxActions.createAction)(ActionTypes.SUBSCRIBE_TO_THREAD_CHANNELS);

var subscribeToThreadChannels = exports.subscribeToThreadChannels = function subscribeToThreadChannels() {
  return function (dispatch, getState) {
    dispatch(subscribeToThreadChannelsAction());

    var client = (0, _getClient.getClient)(getState());
    var channels = (0, _getThreadChannels.getThreadChannels)(getState());

    var subscriptions = channels.reduce(function (acc, channel) {
      acc[channel] = function (message) {
        return dispatch((0, _onMessageReceived.onMessageReceived)(message));
      };
      return acc;
    }, {});

    var promise = client.updateSubscriptions(subscriptions);

    promise.done();
    return promise;
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/subscribeToThreadChannels.js
// module id = 804
// module chunks = 2 3